const DATA_KEY = "bqwOlSSbg9VLtQuMp3mB7OAWQQwrvj6V";
let apiBaseURL = "https://brugjyotis.getlivefeed.xyz/api/v1";
// const apiBaseURL = "http://localhost:4141/api/v1";

if (process.env.NODE_ENV && process.env.NODE_ENV !== "development") {
  apiBaseURL = "https://brugjyotis.getlivefeed.xyz/api/v1";
}

export { DATA_KEY, apiBaseURL };
